import { Box, Paper, Skeleton, Typography } from '@mui/material'
import { PlayCircleFilled } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { StreamService } from '../../services/stream.service'
import { useError } from '../../context/error'
import { PastStream } from '../../_types/stream-status.type'

function formatDuration(seconds: number): string {
  if (!seconds || seconds < 0) return ''
  const m = Math.floor(seconds / 60)
  if (m < 60) return `${m}m`
  const h = Math.floor(m / 60)
  const rest = m % 60
  return rest === 0 ? `${h}h` : `${h}h ${rest}m`
}

export default function LastStream() {
  const { setError } = useError()
  const streamService = new StreamService(setError)
  const [stream, setStream] = useState<PastStream | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    streamService.getRecent().then(res => {
      if (cancelled) return
      const list: PastStream[] = res?.pastStreams ?? []
      const arr = Array.isArray(list) ? list : []
      setStream(arr[0] ?? null)
      setLoading(false)
    })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Paper elevation={1} sx={{ p: 2, height: '100%' }}>
      <Typography variant='subtitle2' fontWeight={700} color='text.secondary' sx={{ letterSpacing: 1, mb: 1 }}>
        LAST STREAM
      </Typography>
      {loading ? (
        <Skeleton variant='rectangular' height={80} sx={{ borderRadius: 1 }} />
      ) : !stream ? (
        <Typography variant='body2' color='text.secondary'>No recent streams.</Typography>
      ) : (
        <RouterLink to='/axxess' style={{ textDecoration: 'none', color: 'inherit' }}>
          <Box display='flex' alignItems='center' gap={1.5}>
            <Box
              sx={{
                width: 96,
                height: 56,
                borderRadius: 1,
                backgroundColor: 'action.hover',
                backgroundImage: stream.thumbnailUrl ? `url(${stream.thumbnailUrl})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <PlayCircleFilled sx={{ color: 'rgba(255,255,255,0.9)', fontSize: 32 }} />
            </Box>
            <Box>
              <Typography variant='subtitle2' fontWeight={600}>
                {new Date(stream.start).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}
              </Typography>
              <Typography variant='caption' color='text.secondary'>
                {formatDuration(stream.duration)} • Watch replay
              </Typography>
            </Box>
          </Box>
        </RouterLink>
      )}
    </Paper>
  )
}
